<template>
  <a class="block hover:bg-gray-50">
    <div class="px-4 py-4 sm:px-6">
      <div class="flex items-center justify-between">
        <p class="text-sm font-medium text-indigo-600 truncate">{{ role }}</p>
        <div class="ml-2 flex-shrink-0 flex">
          <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="setStatusColor">{{ state }}</p>
        </div>
      </div>
      <div class="mt-2 sm:flex sm:justify-between">
        <div class="sm:flex">
          <p class="flex items-center text-sm text-gray-500">
            <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
            </svg>
            {{ resourceName }}
          </p>
        </div>
        <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
          </svg>
          <p>
            {{ dateRange }}
          </p>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    name: '',
    components: {
    },
    data () {
      return {
        trackingValue: [],
        setStatusColor: '',
      }
    },
    created () {
      if (this.roleData.state == "active") {
        this.setStatusColor = 'bg-green-100 text-green-800'
      } else if (this.roleData.state == "inactive") {
        this.setStatusColor = 'bg-yellow-200 text-yellow-800'
      } else if (this.roleData.state == "graduated") {
        this.setStatusColor = 'bg-blue-200 text-blue-800'
      } else if (this.roleData.state == "dropped") {
        this.setStatusColor = 'bg-red-200 text-red-800'
      } else {
        this.setStatusColor = 'bg-blue-200 text-blue-800'
      }
    },
    computed: {
      role () {
        if (this.roleData.name.includes('_')) {
          let roleString = ''

          this.roleData.name.split('_').forEach(i => {
            roleString = roleString + `${i[0].toUpperCase() + i.slice(1)} `
          })

          return roleString
        }

        return this.roleData.name[0].toUpperCase() + this.roleData.name.slice(1)
      },
      resourceName () {
        return this.roleData.relationships.resource ? this.roleData.relationships.resource.name : 'N/A'
      },
      state () {
        return this.roleData.state
      },
      dateRange () {
        // return `${this.roleData.created_at} - ${this.roleData.ineffective_at ? this.roleData.ineffective_at : 'Present'}`
        return `${this.roleData.created_at} - Present`
      },
    },
    methods: {
    },
    props: {
      roleData: {
        type: Object,
        required: true,
      },
    },
    watch: {
    },
  }
</script>

<style lang="scss">
</style>
